import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { AprType } from "@type/HRM/apr";

const { EMPLOYEE_APR, EMPLOYEES } = URLS;

const apiEndpointBase = (id: number) =>
  `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${EMPLOYEES}/${id}/${EMPLOYEE_APR}`;

export const createApr = (() => {
  return async (payload: AprType): Promise<AprType> => {
    const { employeeId, year, mark, aprDocuments, kpiDocuments } = payload.data;

    return api
      .post(`${apiEndpointBase(employeeId)}/reports`, {
        year,
        mark,
        aprDocuments,
        kpiDocuments,
      })
      .then((response) => {
        return response.data;
      });
  };
})();

export const getApr = (() => {
  return async (payload: AprType): Promise<AprType> => {
    const employeeId = payload.data;

    return api.get(apiEndpointBase(employeeId)).then((response) => {
      return response.data.reports;
    });
  };
})();

export const updateApr = (() => {
  return async (data: { data: AprType }): Promise<{ data: AprType }> => {
    return api.put(URLS.EMPLOYEE_APR).then((response) => {
      return { data: response.data };
    });
  };
})();

export const deleteApr = (() => {
  return async (data: { data: AprType }): Promise<{ data: AprType }> => {
    const { employeeId, aprId } = data.data;

    return api
      .delete(`${apiEndpointBase(employeeId)}/reports/${aprId}`)
      .then((response) => {
        return { data: aprId };
      });
  };
})();
